import { useLayoutEffect, useMemo } from 'react'
import { createPortal } from 'react-dom'

import { TOCRail } from './TOCRail'

export const TOC_CONTAINER_ID = 'neruda-toc-container'

export const PortalTOC = () => {
  const tocContainer = useMemo(() => document.createElement('div'), [])

  useLayoutEffect(() => {
    const tocElement = document.getElementById(TOC_CONTAINER_ID)
    tocElement?.appendChild(tocContainer)

    return () => {
      tocElement?.removeChild(tocContainer)
    }
  }, [tocContainer])

  return createPortal(<TOCRail />, tocContainer)
}
